import React from 'react';
import './faculty-ui.css';

export default function Loader({ label = 'Loading...' }) {
  return <div className="ui-loader">{label}</div>;
}
